import { RequestOptions } from './request-options';

export class RecipeStepRequest extends RequestOptions {
    Id_Stage: number;
    Id_Recipe: number;
    StageOrder: number;
    StageText: string;
    ImagePath: string;
    Image: string;
    StateForChange: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-step-request.ts